/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'next-i18next';
import Link from 'src/shared/components/Link';

import RoutePaths from 'src/config/RoutePaths';

import styles from './styles.module.scss';

const DescLineOne = (props) => {
    const { t, step, onClickLoginButton } = props;
    let lineText;

    switch (step) {
        case 1:
            lineText = t('registered_user_description');
            break;
        case 2:
            lineText = t('register-ask-for-back');
            break;
        case 3:
            lineText = t('register-description-final');
            break;
        default:
    }

    return (
        <Fragment>
            <span>{lineText}</span>
            {step === 1 && (
                <Fragment>
                    <span>&nbsp;</span>
                    <Link href={RoutePaths.LOGIN}>
                        <a className={`${styles.loginLink} ${styles.redirectBtn}`} onClick={onClickLoginButton}>
                            {t('login_link')}
                        </a>
                    </Link>
                </Fragment>
            )}
        </Fragment>
    );
};

const DescLineTwo = (props) => {
    const { t, step, isInvestor, onRegisterPageRedirectClick, onBackToPrevClick } = props;
    const registerPageRedirectText = isInvestor ? t('redirect-to-advisor-title') : t('redirect-to-investor-title');
    let lineText;

    switch (step) {
        case 1:
            lineText = t('create');
            break;
        case 2:
            lineText = '';
            break;
        case 3:
            lineText = isInvestor ? '' : t('register-description-final-2');
            break;
        default:
    }

    return (
        <Fragment>
            <span>{lineText}</span>
            {step === 1 && (
                <Fragment>
                    <span>&nbsp;</span>
                    <span className={`${styles.redirectBtn} ${styles.fakeLink}`} onClick={onRegisterPageRedirectClick}>
                        {registerPageRedirectText}
                    </span>
                </Fragment>
            )}
            {step === 2 && (
                <span data-test="registrationBackButton" className={`${styles.redirectBtn} ${styles.fakeLink}`} onClick={onBackToPrevClick}>
                    {t('back-to-prev-step')}
                </span>
            )}
        </Fragment>
    );
};

const Description = (props) => (
    <div className={styles.container}>
        <div className={`${styles.content} ${styles.contentRow}`}>
            <DescLineOne {...props} />
        </div>
        <div className={`${styles.content} ${styles.contentRow}`}>
            <DescLineTwo {...props} />
        </div>
    </div>
);

Description.propTypes = {
    step: PropTypes.number.isRequired,
    isInvestor: PropTypes.bool.isRequired,
    onClickLoginButton: PropTypes.func.isRequired,
    onBackToPrevClick: PropTypes.func.isRequired,
    onRegisterPageRedirectClick: PropTypes.func.isRequired,
};

export default compose(withTranslation())(Description);
